module.exports = __webpack_public_path__ + "img/boton_ocultar_todo.2cf25d12.svg";